import ReactMarkdown from "react-markdown";
import remarkMath from "remark-math";
import rehypeKatex from "rehype-katex";
import clsx from "clsx";
import PropTypes from "prop-types";

// Wide blocks scroll inside themselves instead of widening the page (.markdown-scroll / .markdown-img in Components.css;
// display math is .katex-display there). No tables: they need remark-gfm, which isn't enabled.
// Classed elements instead of a wrapper div: without className ReactMarkdown renders a fragment, and pages style the
// paragraphs as direct children of their own blocks (e.g. `.contest-info > p`).
const components = {
  pre: ({ node, className, ...props }) => <pre className={clsx("markdown-scroll", className)} {...props} />,
  img: ({ node, className, alt, ...props }) => <img className={clsx("markdown-img", className)} alt={alt} {...props} />,
};

export default function Markdown({ className, children }) {
  return <ReactMarkdown
    className={clsx(className)}
    remarkPlugins={[remarkMath]}
    rehypePlugins={[rehypeKatex]}
    components={components}
  >{children}</ReactMarkdown>;
}

Markdown.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
}
